import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getMenuItems() {
    return new Promise((resolve, reject) => {
      api
        .get("dashboard/menu")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  }
  // getMenuItems: function() {
  //     return new Promise((resolve, reject) => {
  //         resolve([
  //             {
  //                 name: 'New',
  //                 url: '/dashboard',
  //                 icon: 'fa fa-plus-circle'
  //             },
  //             {
  //                 name: 'Open project',
  //                 url: '/asd',
  //                 icon: 'fa fa-folder-open'
  //             },
  //             {
  //                 name: 'Open Recent',
  //                 url: '/ddd',
  //                 icon: 'fa fa-history'
  //             },
  //             {
  //                 name: 'Print',
  //                 url: '/wwww',
  //                 icon: 'fa fa-print'
  //             },
  //             {
  //                 name: 'Options',
  //                 url: '/vvvvv',
  //                 icon: 'fa fa-cog'
  //             },
  //             {
  //                 name: 'Exit',
  //                 url: '/bbbb',
  //                 icon: 'fa fa-times'
  //             }
  //             ]
  //         );
  //     })
  // }
};
